import React from 'react'
import { documentToHtmlString } from "@contentful/rich-text-html-renderer"
import parse from 'html-react-parser';
import Vimeo from "@u-wave/react-vimeo";
const Detail = (props) => {
    return (
        <div>
            <div className="projrct-details-wrap" style={{ height: '100vh', padding: '10px 0px', overflowY: 'auto' }}>
                <h1>{props.data?.fields?.title}</h1>
                <div className="">
                    {props.data?.fields?.longDescription && (
                        parse(documentToHtmlString(props.data?.fields?.longDescription))
                    )}
                </div>
                {props.data?.fields?.videosUrl && (
                    <div className="my-3 details_videos">
                        <Vimeo video={props.data?.fields?.videosUrl[0]} autoplay muted />
                    </div>
                )}
                {props.data?.fields?.videosUrl && (
                    props.data?.fields?.videosUrl.slice(1,)
                        .map((video) => {
                            return (
                                <div className="my-3 details_videos">
                                    <Vimeo video={video} muted />
                                </div>
                            )
                        })
                )}
                <div className="post-sldr">

                    {props.data?.fields?.images && (
                        props.data?.fields?.images.map((video) => {
                            return (
                                <div className="post-sldr-img mt-5">
                                    <img src={`https:${video?.fields?.file?.url}`} />
                                </div>
                            )
                        })
                    )}
                    {/* <img src="images/post-sldr-1.jpg" alt="" /> */}
                </div>
                {/* <div className="post-sldr-img">
                        <img src="images/vid-poster-for-dtls.jpg" alt="" />
                    </div> */}
            </div>
        </div>

    )
}

export default Detail